import card1 from "../../../../assets/Wallet/card1.svg";
import card2 from '../../../../assets/Wallet/card2.svg';
import card3 from '../../../../assets/Wallet/card3.svg';
import card4 from '../../../../assets/Wallet/card4.svg';
import card5 from '../../../../assets/Wallet/card5.svg';
import {useEffect,useState} from 'react';
import subcard1 from '../../../../assets/Wallet/subcard1.svg';
import subcard2 from '../../../../assets/Wallet/subcard2.svg';
import subcard3 from '../../../../assets/Wallet/subcard3.svg';
import subcard4 from '../../../../assets/Wallet/subcard4.svg';
import subcard5 from '../../../../assets/Wallet/subcard5.svg';
import dollarsign from "../../../../assets/Dashboard/dollarsign.svg";
import WalletCard from '../../../../components/Cards/WalletCards';
import ManagePayoutTable from "./ManagePayoutTable";
import { Box,Pagination, Typography } from '@mui/material';
import PaymentMethodCard from "./PaymentMethodCard";
import PerformanceChart from "./PerformanceChart";
import CustomText, { textStyles } from "../../../../components/CustomText";
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import back from "../../../../assets/back.svg";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { BASE_URL } from '../../../../components/BaseUrl';
import { decryptToken } from "../../../../Utlis/Encryption";
import { useSelector } from "react-redux";
import DashboardCard from "../../../../components/Cards/DashboardCard";
import dashboardlogo1 from "../../../../assets/Dashboard/dashboardlogo1.svg";
import dashboardlogo2 from "../../../../assets/Dashboard/dashboardlogo2.svg";
import dashboardlogo3 from "../../../../assets/Dashboard/dashboardlogo3.svg";
import dashboardlogo4 from "../../../../assets/Dashboard/dashboardlogo4.svg";
import dashboardlogo5 from "../../../../assets/Dashboard/dashboardlogo5.svg";
import { formatNumber } from "../../../../Utlis/formatNumber";

const MyWallet = () => {
const location = useLocation();
const navigate = useNavigate();
const fromDashboard = location.state?.fromDashboard || false;
      const { t } = useTranslation();
 const rawEncryptedToken = localStorage.getItem("token")
      const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null
   const execIdFromRedux = useSelector((s) => s.auth?.user?.id); // <-- replace with your real path
  const executiveId = execIdFromRedux // fallback for testing
 console.log("id from redux...", executiveId)
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!executiveId || !token) return;

    fetch(`${BASE_URL}/account-executive/${executiveId}/statistics/dashboard`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((res) => {
          console.log("AE Dashboard API Response:", res); 
        if (!res.error) {
          setStats(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching dashboard stats:", err);
      });
  }, [executiveId, token]);

const handleCardClick = (card) => {
  if (card.routePath) {
    navigate(card.routePath,{ state: { fromDashboard: true } });
  } else if (card.anchorPath) {
    navigate(card.anchorPath,{ state: { fromDashboard: true } });
  }
};


   useEffect(() => {
    const scrollId = location.state?.scrollToId;

    if (scrollId) {
      const target = document.getElementById(scrollId);
      if (target) {
        // Delay slightly to allow rendering
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);
  return (
    <Box id='wallet-table'>

{fromDashboard && (
  <Box
    sx={{
      border: '1px solid #E4E6EF',
      borderRadius: 2,
      px: 2,
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 55,
      mb: 2,
      ml:1,
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    >
      <img src={back} style={{ width: 30, height: 30 }} />
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize: '14px',
          color: '#626F86',
          textAlign: 'center'
        }}
      >
        {t('clientsTrialDetails.back')} 
      </CustomText>
    </Box>
  </Box>
)}
<Box
  sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(2, 1fr)",
      md: "repeat(3, 1fr)",
    },
    gap: 2,
    px: 1,
    mt: 2,
  }}
>
  <DashboardCard
    icon={dollarsign}
    title={t("wallet.totalEarned")}
    description={stats ? formatNumber(stats.commissions.total_earned, true) : "..."}
    onClick={() => navigate("/my-wallet", { state: { fromDashboard: true } })}
  />

  <DashboardCard
    icon={dashboardlogo3}
    title={t("wallet.paidEarnings")}
    description={stats ? formatNumber(stats.commissions.paid, true) : "..."}
    onClick={() => navigate("/my-wallet", { state: { fromDashboard: true } })}
  />

  <DashboardCard
    icon={dashboardlogo5}
    title={t("wallet.pendingEarnings")}
    description={stats ? formatNumber(stats.commissions.pending, true) : "..."}
    onClick={() => navigate("/clients-requests", { state: { fromDashboard: true } })}
  />
</Box>

<Box
  sx={{
    display: 'flex',
    flexDirection: {
      xs: 'column', // stack vertically on mobile
      sm: 'row'     // side-by-side from small screens and up
    },
    gap: 1,
    px: 1,
    mt:1.5,
  }}
>
  <Box
    sx={{
      width: {
        xs: '100%',
        sm: '35%'  // 35% on screens ≥600px
      }
    }}
  >
    <PaymentMethodCard />
  </Box>

  <Box
    sx={{
      width: {
        xs: '100%',
        sm: '65%'  // 65% on screens ≥600px
      }
    }}
  >
    <PerformanceChart />
  </Box>
</Box>


<Box>
    <ManagePayoutTable/>
    </Box>
</Box>

  );
};

export default MyWallet;
